import { cls } from '@/utils/cls';

// Small inline loading spinner in brand blue (#274483). Use this for in-place list/detail/tab loading states;
// for full-card or Suspense fallbacks use the Card-wrapped <Loader /> instead.
export function Spinner({ size = 26, className }: { size?: number; className?: string }) {
  return (
    <span
      className={cls(
        'animate-spin inline-block rounded-full border-current border-t-transparent text-[#274483]',
        className,
      )}
      style={{ width: size, height: size, borderWidth: 3 }}
      role="status"
      aria-label="Loading"
    />
  );
}
